<template lang="pug">

  v-list-group(:group="group" :prepend-icon="item.icon" :sub-group="subGroup" append-icon="" color="white")

    template(v-slot:activator)

      v-list-item-icon(v-if="text" class="v-list-item__icon--text" v-text="computedText")

      v-list-item-avatar(v-else-if="userSession.userProfile.img" class="align-self-center" color="grey")
        v-img(:src="userSession.userProfile.img")

      v-list-item-content

        v-list-item-title(style="font-weight: bold;" v-text="userSession.userProfile.nome")

        div

          p(v-if="!freeVersion" style="font-size: 11px").mb-0.mt-2
            | {{ userSession.planName.name }}

          v-btn(small elevation="0" color="transparent" style="padding: 0; margin-top: 5px;" @click.stop.prevent="openLogoutConfirmationBox")
            v-icon.white--text
              | mdi-exit-to-app
            p.ma-0
              | Sair

    template(v-for="(child, i) in children")

      item-sub-group(v-if="child.children" :key="`sub-group-${i}`" :item="child")
      item(v-else :key="`item-${i}`" :item="child" text)

</template>

<script>

  import { freeVersion } from '@/constants'

  // Utilities
  import kebabCase from 'lodash/kebabCase'
  import { mapState/* , mapMutations */ } from 'vuex'

  import ItemSubGroup from './ItemSubGroup'
  import Item from './Item'

  export default {
    name: 'ItemGroup',

    inheritAttrs: false,

    components: {
      'item-sub-group': ItemSubGroup,
      'item': Item,
    },

    props: {
      item: {
        type: Object,
        default: () => ({
          avatar: undefined,
          group: undefined,
          title: undefined,
          plano: undefined,
          children: [],
        }),
      },
      subGroup: {
        type: Boolean,
        default: false,
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    data () {
      return {
        freeVersion: freeVersion,
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
        plans: state => state.app.plans,
      }),

      children () {
        return this.item.children.map(item => ({ ...item, to: !item.to ? undefined : `${this.item.group}/${item.to}` }))
      },

      computedText () {
        if (!this.item || !this.item.title) return ''

        let text = ''

        this.item.title.split(' ').forEach(val => {
          text += val.substring(0, 1)
        })

        return text
      },

      group () {
        return this.genGroup(this.item.children)
      },
    },

    methods: {
      /* ...mapMutations({
        askLogout: 'ASK_LOGOUT',
      }), */

      openLogoutConfirmationBox: function () {
        this.$store.commit('ASK_LOGOUT', true)
        // this.askLogout()
      },

      genGroup (children) {
        return children.filter(item => item.to).map(item => {
          const parent = item.group || this.item.group
          return `${parent}/${kebabCase(item.to)}${item.children ? `|${this.genGroup(item.children)}` : ''}`
        }).join('|')
      },
    },
  }

</script>

<style>

  .v-list-group__activator p {
    margin-bottom: 0;
  }

</style>
